import { userConstants } from './../constants/user.constants';

const initialState = {};

export function UserSearch(state = initialState, action) {
  
  switch (action.type) {
    case userConstants.USERSEARCH_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.USERSEARCH_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.USERSEARCH_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}